export default "/images/a39dfe3350eb5520780b3588fce880c8.png";